<sb-card>
  <div card-header classes="no-border">
    <h3>{{'lang.threeDimensionalImpression.3D_impression' | translate}}</h3>
  </div>
  <div card-fit>
    <div *ngIf="matterportLink" class="embed-container">
      <iframe [src]="matterportLink" allowfullscreen height="500" title="matterport iframe" width="100%"></iframe>
    </div>
    <h3 *ngIf="!matterportLink" class="text-center">{{'lang.threeDImensionalImpression.no_add3D_view' | translate}}
      <a [sbRouterLink]="util.RoutingID.locationDetailsSettings"
         class="link"> {{'lang.threeDimensionalImpression.inLocationAttributes' | translate}}</a>
    </h3>
  </div>
</sb-card>

